import React from 'react';
import { CTAButton } from './CTAButton';
import { CheckList } from './CheckList';
import { BookOpenIcon } from 'lucide-react';
export function ProductSection() {
  const included = ['Estrategias simples para el día a día', 'Juegos que activan el español sin presión', 'Scripts para conversaciones reales', 'Soluciones por edad (3–5, 6–9, 10–12)', 'Técnicas de crianza bilingüe', 'Actividades familiares que generan vínculo', 'Métodos probados en hogares latinos reales'];
  const forYouIf = ['Tu hijo entiende el español pero no lo habla', 'Te responde siempre en inglés', 'Te duele pensar que tu cultura se está apagando', 'No sabes por dónde empezar', 'Ya intentaste apps, clases o videos… y nada funcionó', 'Quieres un plan claro, práctico y probado'];
  return <section className="py-16 px-4 bg-gradient-to-b from-white to-orange-50" data-id="element-93">
      <div className="max-w-5xl mx-auto" data-id="element-94">
        <div className="text-center mb-12" data-id="element-95">
          <BookOpenIcon className="mx-auto text-amber-600 mb-4" size={48} data-id="element-96" />
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-97">
            ¡MIS HIJOS SÍ HABLARÁN ESPAÑOL!
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-98">
            La guía práctica para activar el español en casa — incluso si tus
            hijos hoy solo quieren hablar inglés.
          </p>
        </div>

        <div className="bg-white p-8 md:p-12 rounded-2xl shadow-xl mb-12" data-id="element-99">
          <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-100">Incluye:</h3>
          <CheckList items={included} data-id="element-101" />

          <div className="mt-8 p-6 bg-green-50 border-l-4 border-green-500 rounded-r-lg" data-id="element-102">
            <h4 className="text-xl font-bold text-gray-900 mb-3" data-id="element-103">
              Por qué funciona:
            </h4>
            <p className="text-lg text-gray-800" data-id="element-104">
              Porque no te dice "háblales más"… te muestra cómo convertir el
              español en un lugar emocionalmente seguro y divertido.
            </p>
          </div>
        </div>

        <div className="bg-gradient-to-r from-orange-500 to-amber-500 p-8 md:p-12 rounded-2xl shadow-2xl text-white text-center mb-12" data-id="element-105">
          <h3 className="text-3xl font-bold mb-4" data-id="element-106">🔥 RESULTADO PROMETIDO</h3>
          <p className="text-2xl leading-relaxed" data-id="element-107">
            "En solo 30 días podrás ver a tus hijos usar español
            espontáneamente… incluso si hoy prefieren todo en inglés."
          </p>
        </div>

        <div className="bg-white p-8 md:p-12 rounded-2xl shadow-xl" data-id="element-108">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-109">
            📘 ESTE LIBRO ES PARA TI SI…
          </h3>
          <CheckList items={forYouIf} data-id="element-110" />

          <div className="mt-8 text-center" data-id="element-111">
            <CTAButton size="large" data-id="element-112">Sí, Quiero Esta Guía</CTAButton>
          </div>
        </div>
      </div>
    </section>;
}